import { API_SERVER_PORT, TCP_HOST, TCP_PORT, HTTP_SERVER_PORT } from '../constants';

export const getApiServerBaseURL = () => {
  const loc = window.location;
  let protocol = loc.protocol;
  if (loc.hostname === "localhost" || loc.hostname === "127.0.0.1") {
    return `http://${loc.hostname}:${HTTP_SERVER_PORT}`
  }
  return `${protocol}//${loc.hostname}:${API_SERVER_PORT}`;
};

export const getTCPServerBaseURL = () => {
  const loc = window.location;
  let newURL = '';
  if (loc.protocol === 'https:') {
    newURL += 'wss:';
  } else {
    newURL += 'ws:';
  }
  newURL += `//${TCP_HOST}:${TCP_PORT}/`;

  return newURL;
};
